module.exports = __webpack_public_path__ + "static/img/spring_jianjiePic.fc6ef295.png";